import { useState } from 'react';
import styled from 'styled-components';

import { ActionBar, ButtonVariant } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../translations';

import { MedicalServiceCreateModalOpener } from './create/MedicalServiceCreateModalOpener';
import { MedicalServiceTable } from './table/MedicalServiceTable';
import { MedicalServiceTableSearch } from './table/MedicalServiceTableSearch';

const StyledMedicalServicePanel = styled.div`
   display: flex;
   flex-direction: column;
   gap: 12px;
   overflow: auto;
   height: 100%;
`;

StyledMedicalServicePanel.displayName = 'StyledMedicalServicePanel';

const MedicalServiceCreatePrimaryButton = (): JSX.Element => {
   return (
      <MedicalServiceCreateModalOpener>
         {({ openModal }) => (
            <ActionBar.PrimaryButton
               testId={'medicalServiceCreate'}
               label={medicalServiceTranslationKeys.panel.actionBar.create}
               variant={ButtonVariant.PRIMARY}
               onClick={openModal}
            />
         )}
      </MedicalServiceCreateModalOpener>
   );
};

type MedicalServicePanelProps = {
   readonly hasMorePractitioners: boolean;
};

export const MedicalServicePanel = (props: MedicalServicePanelProps): JSX.Element => {
   const [searchText, setSearchText] = useState<string | null>(null);
   return (
      <>
         <StyledMedicalServicePanel>
            <MedicalServiceTableSearch onChange={setSearchText} />
            <MedicalServiceTable searchText={searchText} hasMorePractitioners={props.hasMorePractitioners} />
         </StyledMedicalServicePanel>
         <MedicalServiceCreatePrimaryButton />
      </>
   );
};
